import React, { createContext, useState } from "react";

export const SearchFutureCustomerPersonaContext = createContext({});

export const initialSearchValues = {
  yearOfBudgets: [],
  companyType: "", //id from dropdown
  nationalityList: "", //id ของสัญชาติ ใน dropdown
  industryType: [], //id from dropdown
  countryList: [],
  statusList: [],
  companyName: "",
  contactName: "",
  contactDateFrom: "",
  contactDateTo: "",
  areaSizeByRaiMin: "",
  areaSizeByRaiMax: "",
  areaSizeByNganMin: "",
  areaSizeByNganMax: "",
  areaSizeByWaMin: "",
  areaSizeByWaMax: "",
  areaSizeByMetersMin: "",
  areaSizeByMetersMax: "",
  waterConsumptionMin: "",
  waterConsumptionMax: "",
  wasteWaterMin: "",
  wasteWaterMax: "",
  kwMin: "",
  kwMax: "",
  areaType: "", //id from dropdown
  isInvestmentAdvice: null,
  isVisitAreaLandInfo: null,
  channels: "", //id from d
  futureCustomerId: "",
};

export const initialPageValues = {
  page: 0,
  pageSize: 1,
  total: 0,
  totalPage: 0,
  sortBy: "yearOfBudget",
  sortDirection: "ASC",
};

const SearchFutureCustomerPersonaProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  const [futureCusId, setFutureCusId] = useState(null);
  return (
    <SearchFutureCustomerPersonaContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
        futureCusId,
        setFutureCusId,
      }}
    >
      {children}
    </SearchFutureCustomerPersonaContext.Provider>
  );
};

export default SearchFutureCustomerPersonaProvider;
